import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  LinkAuthenticationElement,
  PaymentElement,
} from "@stripe/react-stripe-js";
import styles from "./style.module.css"
import { connect, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify';
import { BreathAPIs } from '../APIs/BreathAPIs';
import { addAmount, loadUser } from '../Actions/Auth';
import CardUI from './CardUI';
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import { Checkbox, notification, Space, Button, Modal } from 'antd';
import { useEffect } from 'react';
import { PiWarningCircleBold } from "react-icons/pi";
import TooltipView from '../Dashboard/components/AdminDashboard/TooltipView';
import CardBlock from '../CardBlock/CardBlock';



const CheckOutForm = ({ setWalletRechargeModal, jwt, balance, setPaymentOptionAmount, autopayProp, walletRechargeModal, userID, amountToAdd, defaultCard, autoPayThreshold }) => {
  console.log(autopayProp)
  const [userNRBookings, setUserNRBookings] = useState([])
  const [noOfMethods, setNoOfMethods] = useState(0);
  const [paymentMethods, setPaymentMethods] = useState([])
  const [activeKey, setActiveKey] = useState("1")
  const [selectedCard, setSelectedCard] = useState(defaultCard !== null ? defaultCard : '');
  const [selectedCardDetails, setSelectedCardDetails] = useState({})

  const tagsData = [20, 25, 30, 35];
  const [selectedTags, setSelectedTags] = React.useState(autoPayThreshold);
  const [amountLoader, setAmountLoader] = useState(false)
  const [loadingTag, setLoadingTag] = useState(null)
  const [topUpAmountChangeConfirmation, setTopUpAmountChangeConfirmation] = useState(false)
  const [autoPayAmountAlert, setAutoPayAmountAlert] = useState(false)


  useEffect(() => {
    setAutoPay(autopayProp)
    getUserCurrentBookings();
    getPaymentMethods();
    console.log("activeKey", activeKey)
    loadUser()
  }, [defaultCard])
  console.log("activeKey", activeKey)
  const togglePanel = (key) => {
    if (activeKey === key) {
      // If the current key is being closed, keep it open
      return;
    }
    setActiveKey(key); // Set the new active panel
  };

  const handleChange = async (tag, checked) => {
    setAmountLoader(true)
    // console.log("auto pay tag change: ", tag, checked)
    try {
      let res = await BreathAPIs.updateAutoPaySetting(Number(tag));

      if (checked && res.data.success) {
        setSelectedTags(tag)
        toast.success("Wallet max amount updated")
        const userWalletDetails = await BreathAPIs.getAmount(jwt)
        let amountInCents = userWalletDetails.data.walletCoins >= 5 ? 100 : (Number(tag) - userWalletDetails.data.walletCoins) * 100
        amountInCents = amountInCents <= 50 ? 100 : amountInCents

        console.log("setting amounts in auto pay condition : ", amountInCents / 100)
        setAmount(amountInCents / 100)
        setPaymentOptionAmount(amountInCents / 100)
      } else {
        setAutoPayAmountAlert(true)
        setTimeout(() => {
          setAutoPayAmountAlert(false)
        }, 5000)
      }
      setAmountLoader(false)

    } catch (error) {
      setAutoPayAmountAlert(true)
      setTimeout(() => {
        setAutoPayAmountAlert(false)
      }, 5000)
      setAmountLoader(false)
      // console.log("error updating auto pay amount setting: ", error)
    }


  };


  const getPaymentMethods = async () => {
    try {
      console.log("Inside get payment methods function")
      const res = await BreathAPIs.getStripePaymentMethods(jwt, 'card')
      console.log("Payment methods", res.data)
      res.data.paymentMethods === 0 ? setActiveKey('2') : setActiveKey('1')
      setNoOfMethods(res.data.paymentMethods);
      setPaymentMethods(res.data.methodList)

    } catch (error) {

    }
  }

  const getUserCurrentBookings = async () => {
    const res = await BreathAPIs.getUpcomingBookings()
    console.log(res)

    res.data.map((b) => {
      if (b.user._id === userID) { //&& b.nonReservable
        // console.log(b)
        setUserNRBookings([...userNRBookings, b])
      }
    })
  }
  const [cardInfo, setCardInfo] = useState({
    last4: "",
    brand: "",
    exp_month: "",
    exp_year: ""
  });


  const [amount, setAmount] = useState(amountToAdd !== null ? amountToAdd : 10); // Default to 10 dollars

  // console.log("setting setpaymet optionamount in code: ", amountToAdd)
  // setPaymentOptionAmount(amountToAdd !==null ? amountToAdd : 10)
  const stripe = useStripe();
  const elements = useElements();

  const [isLoading, setIsLoading] = useState(false);

  const [autoPay, setAutoPay] = useState(autopayProp) //have to set based on user db
  const [paymentMethod, setPaymentMethod] = useState('card')
  const [paymentFormCollapsed, setPaymentFormCollapsed] = useState(true)
  const [enablePay, setEnablePay] = useState(true)
  const [saveCard, setSaveCard] = useState(false)
  const dispatch = useDispatch();


  useEffect(() => {
    setAmount(autoPay ? (amount !== null ? amount : amountToAdd) : amountToAdd)
  }, [])




  // getAmountToAdd(amount)

  const handleError = (error) => {
    // console.log(error);
    toast.error(error);
  }
  function formatStripeError(errorString) {
    // Replace underscores with spaces
    let formattedString = errorString.replace(/_/g, ' ');
    formattedString = formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
    return formattedString
  }

  const addToTransactionHistory = async (amount, status, type) => {
    // console.log("need to add in trans his")
    setIsLoading(true);
    const res = await BreathAPIs.createTransactionHistory({
      dateEpoch: Math.floor(new Date().getTime() / 1000.0), // epoch value in GMT need to convert it into zone base 
      amount: amount,
      status: status,
      type: type
    })
    setIsLoading(false);
    // console.log(res.data)
  }
  const updateWalletCoins = (amount) => {
    dispatch(addAmount(amount));
    // console.log(res)
    // const res = await BreathAPIs.updateWalletCoins(jwt, amount);

    // console.log(res.data)
    // console.log(res)
    // return res; 
  }



  const handleSubmit = async (event) => {
    console.log("inside handle submit")
    setIsLoading(true)
    event.preventDefault();

    if (!stripe || !elements) {
      console.log("NO STRIPE LOADED")
      setIsLoading(false)
      return; // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
    }
    if (amount < 10 && !autoPay) {
      alert("Please enter a minimum of $10.");
      setIsLoading(false)
      setAmount(10)
      setPaymentOptionAmount(10)
      return;
    }
    try {
      const userWalletDetails = await BreathAPIs.getAmount(jwt)

      if ((parseFloat(userWalletDetails.data.walletCoins) + parseFloat(amount)) > userWalletDetails.data.maxLimit) {
        alert(`Maximum amount in wallet should not exceed ${userWalletDetails.data.maxLimit}`)
        setIsLoading(false)
        return
      }

      let amountInCents;

      // console.log("Auto pay", autoPay)

      if (autopayProp === true || autoPay === true) {

        amountInCents = userWalletDetails.data.walletCoins >= 5 ? 100 : (Number(selectedTags) - userWalletDetails.data.walletCoins) * 100
        amountInCents = amountInCents <= 50 ? 100 : amountInCents

        console.log("setting amounts in auto pay condition : ", amountInCents / 100)
        setAmount(amountInCents / 100)
        setPaymentOptionAmount(amountInCents / 100)
      }
      else {
        amountInCents = amount * 100;
      }

      if ((autopayProp === true || autoPay === true) && activeKey === '2') {

        console.log("Inside autop")
        let res;
        // const cardElement = elements.getElement(CardElement)
        // console.log("Inside autop after get elemetn")
        // if (!cardElement) {
        //   toast.error("Could not process payment")
        //   setIsLoading(false)
        //   return
        // }
        // console.log("in card elem")
        // let res

        // const { error: pmError, paymentMethod } = await stripe.createPaymentMethod({
        //   type: "card",
        //   card: cardElement,
        // });
        // console.log(pmError)
        // if (pmError) {
        //   toast.error(pmError.message)
        //   setIsLoading(false)
        //   setAmount(10)
        //   return
        // }

        // console.log("paymentMethod", paymentMethod)

        // let res;
        // try {
        //   res = await BreathAPIs.addToWallet(amountInCents, jwt, autoPay, saveCard);
        //   console.log("4) addToWallet ok");
        // } catch (e) {
        //   console.error(" addToWallet THREW", e);
        //   setIsLoading(false)
        //   throw e;
        // }

        // const clientSecret = res.data.paymentIntent.client_secret;
        // console.log("5) clientSecret", clientSecret);

        // console.log("6) before confirmPayment");
        // let confirmResult;
        // try {
        //   confirmResult = await stripe.confirmPayment({
        //     elements,
        //     clientSecret,
        //     confirmParams: { return_url: process.env.REACT_APP_BASE_URL },
        //     redirect: "if_required",
        //   });
        //   console.log("7) confirmPayment result", confirmResult);
        // } catch (e) {
        //   console.error(" confirmPayment THREW", e);
        //   toast.error(e?.message || "Payment failed");
        //   setIsLoading(false);
        //   return;
        // }
        console.log("1) before elements.submit");
        let submitResult;
        try {
          submitResult = await elements.submit();
          console.log("2) elements.submit result", submitResult);
        } catch (e) {
          console.error(" elements.submit THREW", e);
          setIsLoading(false)
          throw e;
        }

        if (submitResult?.error) {
          console.log("✅ elements.submit returned an error", submitResult.error);
          setIsLoading(false)
          toast.error(formatStripeError(submitResult?.error));
          return;
        }

        try {
          res = await BreathAPIs.addToWallet(amountInCents, jwt, autoPay, saveCard)
        } catch (error) {
          console.log(error)
        }

        console.log("Res", res)
        const clientSecret = res.data.paymentIntent.client_secret
        console.log("CL SE", clientSecret)

        const { error } = await stripe.confirmPayment({
          elements,
          clientSecret,
          confirmParams: {
            return_url: process.env.REACT_APP_BASE_URL,
          },
          // Uncomment below if you only want redirect for redirect-based payments
          redirect: "if_required",
        })

        if (error) {

          console.log("inside error set amount 10")
          toast.error(formatStripeError(error.code))
          setIsLoading(false)
          setAmount(10)
          setPaymentOptionAmount(10)
          return
        }
        else {
          updateWalletCoins(amountInCents / 100)
          toast.success("$" + (amountInCents / 100).toFixed(2) + " added to wallet.")
          addToTransactionHistory(amountInCents / 100, "success", "Credit")

          if (activeKey === '1') {
            const res = await BreathAPIs.updateProfile({ isAutoPayEnabled: autoPay, selectedPaymentMethod: selectedCard })
          }
          else {
            const latestPaymentMethods = await BreathAPIs.getStripePaymentMethods(jwt, '')
            let latestPaymentMethod = latestPaymentMethods.data.methodList[0].id;

            const res = await BreathAPIs.updateProfile({ isAutoPayEnabled: autoPay, selectedPaymentMethod: latestPaymentMethod })
          }
          setWalletRechargeModal(false)
          setIsLoading(false)
          return
        }

      } else {

      }

      let res;
      console.log("activeKey", activeKey)
      let error;
      if (activeKey === '1') {
        console.log("In paymetn from selected card")
        res = await BreathAPIs.addAmountFromCard(amountInCents / 100, selectedCard, jwt)
        const clientSecret = res.data.paymentIntent.client_secret;

        ({ error } = await stripe.confirmPayment({
          clientSecret,
          confirmParams: {
            return_url: process.env.REACT_APP_BASE_URL,
          },
          // Uncomment below if you only want redirect for redirect-based payments
          redirect: "if_required",
        }))
      } else {
        // openNotification()
        // const { error: submitError } = await elements.submit();
        // if (submitError) {
        //   // console.log("submitError", submitError)
        //   // console.log("error", error)
        //   toast.error(formatStripeError(submitError.code));
        //   setIsLoading(false)
        //   setAmount(10)
        //   return;
        // }

        // res = await BreathAPIs.addToWallet(amountInCents, jwt, autoPay, saveCard)
        // const clientSecret = res.data.paymentIntent.client_secret;

        // //const {client_secret: clientSecret} = await res.json();
        // //const clientSecret = 'pk_test_51MgMVRAPmgE2jEzZNLL7fojhCo052rXCR634fbmKPaVZL3lM1kM4QtRUWU6RvFl2BmQMeDBucOpgQDuDBV0lJ9ov00PmEkcwVC'
        // ({ error } = await stripe.confirmPayment({
        //   elements,
        //   clientSecret,
        //   confirmParams: {
        //     return_url: process.env.REACT_APP_BASE_URL,
        //   },
        //   // Uncomment below if you only want redirect for redirect-based payments
        //   redirect: "if_required",
        // }));
        // console.log(res);

        console.log("1) before elements.submit");
        let submitResult;
        try {
          submitResult = await elements.submit();
          console.log("2) elements.submit result", submitResult);
        } catch (e) {
          console.error(" elements.submit THREW", e);
          setIsLoading(false)
          throw e;
        }

        if (submitResult?.error) {
          console.log("✅ elements.submit returned an error", submitResult.error);
          setIsLoading(false)
          toast.error(formatStripeError(submitResult?.error));
          return;
        }

        console.log("3) before addToWallet");
        let res;
        try {
          res = await BreathAPIs.addToWallet(amountInCents, jwt, autoPay, saveCard);
          console.log("4) addToWallet ok");
        } catch (e) {
          console.error(" addToWallet THREW", e);
          setIsLoading(false)
          throw e;
        }

        const clientSecret = res.data.paymentIntent.client_secret;
        console.log("5) clientSecret", clientSecret);

        console.log("6) before confirmPayment");
        let confirmResult;
        try {
          confirmResult = await stripe.confirmPayment({
            elements,
            clientSecret,
            confirmParams: { return_url: process.env.REACT_APP_BASE_URL },
            redirect: "if_required",
          });
          console.log("7) confirmPayment result", confirmResult);
        } catch (e) {
          console.error(" confirmPayment THREW", e);
          toast.error(e?.message || "Payment failed");
          setIsLoading(false);
          return;
        }


        error = confirmResult?.error;

      }
      console.log("Beofre if in active key 2")

      if (error) {
        //handleError(error);
        // console.log(error);
        toast.error(formatStripeError(error.code));
        setIsLoading(false)
      }
      else {
        console.log("No errors addign to wallet")
        updateWalletCoins(amountInCents / 100)
        toast.success("$" + (amountInCents / 100).toFixed(2) + " added to wallet.")
        addToTransactionHistory(amountInCents / 100, "success", "Credit")
        if (autoPay === true || autopayProp === true) {
          if (activeKey === '1') {
            const res = await BreathAPIs.updateProfile({ isAutoPayEnabled: autoPay, selectedPaymentMethod: selectedCard })
          }
          else {
            const latestPaymentMethods = await BreathAPIs.getStripePaymentMethods(jwt, '')

            let latestPaymentMethod = latestPaymentMethods.data.methodList[0].id;

            const res = await BreathAPIs.updateProfile({ isAutoPayEnabled: autoPay, selectedPaymentMethod: latestPaymentMethod })
          }
        }
        setWalletRechargeModal(false)
        setIsLoading(false)

      }

    } catch (error) {
      console.log("")
      setIsLoading(false)
      toast.error("Payment Failed. Please try again.")
    }
  }

  console.log(autoPay)

  const enableAutoPay = async (e) => {
    console.log("e.tgt.checked", e.target.checked)
    if (!e.target.checked) {

      console.log("inside if condition in enable auto pay ")
      setEnablePay(true);
      setAmount(10)
      setPaymentOptionAmount(10)
    }
    let amountInCents;
    const userWalletDetails = await BreathAPIs.getAmount(jwt)
    if (e.target.checked) {

      amountInCents = userWalletDetails.data.walletCoins >= 5 ? 100 : (Number(selectedTags) - userWalletDetails.data.walletCoins) * 100
      amountInCents = amountInCents <= 50 ? 100 : amountInCents

      console.log("setting amounts in auto pay condition : ", amountInCents / 100)
      setAmount(amountInCents / 100)
      setPaymentOptionAmount(amountInCents / 100)
    }
    else {
      amountInCents = amount * 100;
    }



    setAutoPay && setAutoPay(e.target.checked);
    await checkAutoPayConditions(paymentMethod, e.target.checked)
  }

  const onPaymentElementChange = async (e) => {
    setSaveCard(e.value.type !== 'card' ? false : saveCard)
    setPaymentMethod(e.value.type)
    console.log(e.value.type)
    setPaymentFormCollapsed(e.collapsed)
    await checkAutoPayConditions(e.value.type)

  }

  const checkAutoPayConditions = async (method = '', enablePay = autoPay) => {
    console.log("Enable pay", enablePay)
    try {

      const res = await BreathAPIs.getStripePaymentMethods(jwt, '')
      console.log(res.data.paymentMethods)
      console.log("Payment method in check ", method)
      if (method !== 'card' && method !== 'apple_pay' && enablePay === true && activeKey === '2') {
        //Promtp user to add card details and disable pay button
        setEnablePay(false)
        setAutoPay(false)
        console.log("Enter card details if")
      } else {
        console.log("Enter card details else")
        setEnablePay(true)
      }

    } catch (error) {
      console.log("Error in getting no of payment methods", error.message)
    }
  }

  const options = {
    payment_method_types: ['card']
  }
  return (
    <div className={styles.formContainer}>

      <ToastContainer></ToastContainer>

      {(!autopayProp && !autoPay) ?
        <div className={styles.formField}>
          <label className="form-label fw-bold"> Amount ($):</label>
          <input
            className={`${styles.glassmorphic} form-control ${amount <= 9 ? styles['is-invalid'] + ' is-invalid ' : ''}`}
            type="number"
            value={amount}
            onChange={(e) => { setAmount(e.target.value); e.target.value >= 10 ? setPaymentOptionAmount(e.target.value) : setPaymentOptionAmount(autoPay ? amount : 10) }}
            min="10"
            required
          />

        </div>
        :
        <>
          {
            noOfMethods === 0 &&
            <div className={styles.formFieldHide}><h5 style={{ paddingTop: 0 }}>Add new payment method</h5></div>}
        </>
      }

      {
        // console.log("no of pamyment methods, method list",noOfMethods,paymentMethods)
        noOfMethods === 0 ?

          <div className={styles.stripeContainer}>
            {
            // !(autoPay || autopayProp) ?

              <PaymentElement onChange={(e) =>
                onPaymentElementChange(e)
              }
                options={options}
              ></PaymentElement>

              // :
              // <div className={styles['CardElement']}>
              //   <CardElement></CardElement>
              // </div>

            }
            {
              paymentMethod === 'card' && !autoPay ?
                <div className={styles.saveCardContainer}>
                  <Checkbox onChange={(e) => setSaveCard && setSaveCard(e.target.checked)} checked={saveCard}>
                    <span className={styles.saveCard}>Would you like to save this card for future usage?</span>
                  </Checkbox>
                </div>
                :
                <></>
            }
          </div>
          :
          <>
            {
              <>
                <div className={"paymentContainer"}>
                  <div className="accordion" id="accordionExample">
                    {/* Accordion Item 1 */}
                    <div className="accordion-item">
                      <h2 className={`${styles.accordionHeader} accordion-header`} id="headingOne" >
                        <button
                          className={`accordion-button ${activeKey === "1" ? "" : "collapsed"} `} //${styles.addMargin}
                          type="button"
                          onClick={() => togglePanel("1")}
                          aria-expanded={activeKey === "1"}
                          aria-controls="collapseOne"
                        >
                          {autopayProp ? "Select an existing method" : "Pay with an existing method"}
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className={`accordion-collapse collapse ${activeKey === "1" ? "show" : ""}`}
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div className={styles.existingCards}>

                            {paymentMethods.map((m) => {
                              return (
                                selectedCard === m.id ?
                                  <CardBlock
                                    key={m.id}
                                    type={m.card.brand}
                                    number={m.card.last4}
                                    expiry={`${m.card.exp_month}/${m.card.exp_year}`}
                                    id={m.id}
                                    selected
                                    wallet={m.card.wallet}
                                  ></CardBlock>
                                  :
                                  <CardBlock
                                    key={m.card.id}
                                    type={m.card.brand}
                                    number={m.card.last4}
                                    expiry={`${m.card.exp_month}/${m.card.exp_year}`}
                                    id={m.card.id}
                                    onClick={() => { setSelectedCard(m.id); setSelectedCardDetails(m); }}
                                    wallet={m.card.wallet}
                                  ></CardBlock>
                              )
                              // <div>{m.card.brand} {m.card.last4}</div>
                            })}
                          </div>
                          {/* <ButtonCustom text={"Enable"} style={{"width": "100%","margin-top":"34px"}} onClick={()=>{sendPaymentIntent(selectedCard)}} isLoading={isLoading}></ButtonCustom> */}
                        </div>
                      </div>
                    </div>

                    {/* Accordion Item 2 */}
                    <div className="accordion-item">
                      <h2 className={`${styles.accordionHeader} accordion-header`} id="headingTwo">
                        <button
                          className={`accordion-button ${activeKey === "2" ? "" : "collapsed"}`}
                          type="button"
                          onClick={() => togglePanel("2")}
                          aria-expanded={activeKey === "2"}
                          aria-controls="collapseTwo"
                        >
                          Add new payment method
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className={`accordion-collapse collapse ${activeKey === "2" ? "show" : ""}`}
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div className={`accordion-body ${styles.accordionBodyVisible}`}>
                          <div>

                            {/* {
                                !(autoPay || autopayProp) ?

                                  <PaymentElement onChange={(e) =>
                                    onPaymentElementChange(e)
                                  }
                                    options={options}
                                  ></PaymentElement>
                                  :
                                  <div>
                                    <div className={styles['CardElement']}>
                                      <CardElement></CardElement>
                                    </div>
                                    <p className={styles.stripeFormText}>
                                      By providing your card information, you allow BreatheEV Inc to charge your card for future payments in accordance with their terms.
                                    </p>
                                  </div>
                              } */}
                            <PaymentElement onChange={(e) =>
                              onPaymentElementChange(e)
                            }
                              options={options}
                            ></PaymentElement>
                            {console.log("Autopay", autoPay, autopayProp)}
                            {

                              paymentMethod === "card" && !autoPay ?
                                <div className={styles.saveCardContainer}>
                                  <Checkbox onChange={(e) => setSaveCard(e.target.checked)} checked={saveCard}>
                                    <span className={styles.saveCard}>Would you like to save this card for future usage?</span></Checkbox>
                                </div>
                                :
                                <></>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Accordion Item 3 */}

                  </div>
                </div>
              </>

            }
          </>
      }
      {
        paymentFormCollapsed === true && !autopayProp ?
          <p class="placeholder-wave">
            <span className={`placeholder col-12 rounded ${styles.loaderBar}`}></span>
          </p>
          :
          <div className={styles.autoReloadCheckbox}>

            {
              (!autopayProp && (paymentMethod === 'card' || paymentMethod === 'apple_pay')) &&
              <>
                {/* {console.log("Payment Type", paymentMethod, userNRBookings.length > 0 && autoPay || (paymentMethod !== 'card' && paymentMethod !== 'apple_pay') ? true : false)} */}
                <Checkbox onChange={(e) => enableAutoPay(e)} checked={autoPay} disabled={userNRBookings.length > 0 && autopayProp || (paymentMethod !== 'card' && paymentMethod !== 'apple_pay') ? true : false}>
                  <span>Enable Auto Reload</span></Checkbox>
                {/* <TooltipView
                  text={
                    // <span>
                      `By enabling auto reload, we ensure that your wallet balance is always maintained at $${selectedTags ? selectedTags : autoPayThreshold}.`
                    // </span> 
                  }
                  clsName={"paymentFormStyle"}
                /> */}
                {/* {autoPay && 
                <>
                                
                                <div className={styles['auto-pay-checkout-div']}>
                                <p>Select wallet max amount </p>
                                <div 
                                className={styles['auto-pay-amount-selection-checkout-form']}
                                >
                                    
                                    {tagsData.map((tag) => {
                                        // 1. Determine if THIS specific tag is the one loading
                                        const isThisTagLoading = amountLoader && tag === loadingTag;
                                        const isSelected = selectedTags === tag;

                                        return (
                                            <span
                                                key={tag}
                                                // Use CSS to handle the 'disabled' look/feel since spans don't have a native disabled attr
                                                className={`auto-pay-amount-tag ${isSelected ? 'selected-tag' : ''} ${amountLoader ? 'disabled-tag' : ''}`}
                                                style={{
                                                    pointerEvents: amountLoader ? 'none' : 'auto',
                                                    opacity: amountLoader && !isThisTagLoading ? 0.6 : 1
                                                }}
                                                onClick={(e) => {
                                                    if (!amountLoader) {
                                                        setLoadingTag(tag); // Track which tag was clicked
                                                        handleChange(tag, true);
                                                        // setTopUpAmountChangeConfirmation(true)
                                                    }
                                                }}
                                            >
                                                {isThisTagLoading ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    `$${tag}`
                                                )}
                                            </span>
                                        );
                                    })}

                                </div>
                                </div>
                            </>
                            } */}
              </>
            }
            {(autoPay) && <>
              {/* <div className='auto-pay-amount-selection-header'>
                                    Select Auto Pay Amount
                                </div> */}
              <div className={styles['auto-pay-checkout-div']}>
                <p>Select wallet max amount </p>
                <div
                  className={styles['auto-pay-amount-selection-checkout-form']}
                >

                  {tagsData.map((tag) => {
                    // 1. Determine if THIS specific tag is the one loading
                    const isThisTagLoading = amountLoader && tag === loadingTag;
                    const isSelected = selectedTags === tag;

                    return (
                      <span
                        key={tag}
                        // Use CSS to handle the 'disabled' look/feel since spans don't have a native disabled attr
                        className={`auto-pay-amount-tag ${isSelected ? 'selected-tag' : ''} ${amountLoader ? 'disabled-tag' : ''}`}
                        style={{
                          pointerEvents: amountLoader ? 'none' : 'auto',
                          opacity: amountLoader && !isThisTagLoading ? 0.6 : 1
                        }}
                        onClick={(e) => {
                          if (!amountLoader) {
                            setLoadingTag(tag); // Track which tag was clicked
                            handleChange(tag, true);
                            // setTopUpAmountChangeConfirmation(true)
                          }
                        }}
                      >
                        {isThisTagLoading ? (
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                          `$${tag}`
                        )}
                      </span>
                    );
                  })}

                </div>
              </div>
            </>
            }
          </div>}
      {topUpAmountChangeConfirmation && <Modal
        title="Confirm Auto reload Update"
        open={topUpAmountChangeConfirmation}
        onOk={() => { setTopUpAmountChangeConfirmation(false); handleChange(loadingTag, true); }}
        okText="Update"
        onCancel={() => { setTopUpAmountChangeConfirmation(false); setLoadingTag(null); }}

      >
        <p>Auto reload top-up amount will be updated to ${loadingTag}. This change will apply to your next automatic reload.</p>
      </Modal>}
      {
        // check payment lenght of card payment methods 
        // check payment method from form
        // if card payemnt methods.lenth === 0 and payment method =! card disable pay button => promt user to enter card details
        !enablePay &&
        <div className={styles.provideAutoPay}>
          <PiWarningCircleBold className={styles.cardDetailWarningIcon}></PiWarningCircleBold> <span className={styles.cardDetailWarning}>Please select a different payment method for enabling auto reload feature</span>
        </div>
      }
      {
        autoPay &&
        <div className={autoPay ? styles.validationAmountInfoAutopay : styles.validationAmountInfo}>
          $1 will be added to your wallet for validation, or the wallet will be topped up to reach ${selectedTags ? selectedTags : autoPayThreshold} if the balance is below $5
        </div>
      }

      <div className='mt-4'>
        {
          console.log("button cond", paymentMethod, isLoading)
        }
        <ButtonCustom type="button"
          text={isLoading ? "Loading...." : autopayProp ? 'Update' : 'Pay'}
          disabled={!stripe || isLoading || !enablePay ||
            (activeKey === '1' && selectedCard === '') ||
            (selectedCard === defaultCard && activeKey === '1' && autopayProp) ||
            (autoPay && (paymentMethod !== 'card' && paymentMethod !== 'apple_pay'))}
          isLoading={isLoading} style={{ width: "100%" }} onClick={handleSubmit} />
      </div>
      {/* <button type="submit" disabled={!stripe || isLoading} className={`${styles.payButton} btn btn-primary mt-2`}>
                {isLoading ? "Loading...." : 'Pay'}
            </button> */}
      {/* </form>  */}
    </div>
  );
}

CheckOutForm.propTypes = {
  jwt: PropTypes.string,
  balance: PropTypes.number,
  autopayProp: PropTypes.bool,
  userID: PropTypes.string,
  defaultCard: PropTypes.string,
  autoPayThreshold: PropTypes.number,
}

const mapStateToProps = state => ({
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  jwt: state.auth ? state.auth.token : null,
  autopayProp: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  defaultCard: state.auth && state.auth.user ? state.auth.user.selectedPaymentMethod : null,
  autoPayThreshold: state.auth && state.auth.user ? state.auth.user.autoPayThreshold : 20,
})

export default connect(mapStateToProps, {})(CheckOutForm);




